import React from "react";
import CalculCapaciteEmprunt from "../components/CalculCapaciteEmprunt";
import { useSEO } from "../hooks/useSEO";

export default function CalculCapaciteEmpruntPage() {
  useSEO({
    title: "Calculateur Capacité d'Emprunt Immobilier Gratuit",
    description: "Calculez gratuitement votre capacité d'emprunt immobilier. Découvrez combien vous pouvez emprunter selon vos revenus et votre taux d'endettement."
  });

  return <CalculCapaciteEmprunt />;
}
